/* eslint-disable max-len */
import * as UI from 'ui';
import * as AddFeature from 'app/area/case/features';
import * as Select from 'app/area/case/selectors';
import * as AppEnhance from 'app/components/enhancers';
import * as UIEnhance from 'ui/common/enhancers';
import {tableName, columnName} from 'app/area/case/case-data-model';
import * as caseComponents from 'app/area/case/components';
import * as appComponents from 'app/components';
import { ControlType, IteratorType } from 'app/infrastructure/ui';
import { ComponentIndex } from 'app/infrastructure/ui/types-uischema';
import { Dummy, OpenPanel, ReadPanel } from 'app/infrastructure/ui/debug-render';
import { SharePreset, UnlockPreset } from 'app/area/case/features';
import { withCopyRiskEvaluation, withGetUiDefinition } from 'app/area/case/features/loss-potential-evaluation';
import * as caseData from 'app/area/case/case-data-model';

const Enhance = {...AppEnhance, ...UIEnhance};

export const readModeComponents: ComponentIndex =  {

  [ControlType.NotImplemented]: {
    component: Dummy,
    configType: ControlType.NotImplemented
  },
  [ControlType.View]: {
    component: UI.Paper,
    selectors: [
      Select.sharedState,
      Select.activeSectionState,
      Select.nextAndPreviousSection,
      Select.caseId,
      Select.print,
      Select.fieldValues([{dataTag: 'Title', fieldName: 'title'}])
    ],
    enhancers: [
      Enhance.withDocumentTitleFromProps('title.valueObject.value', 'caseId'),
      Enhance.withSectionKeyboardPaging(),
      Enhance.withPrint()
    ],
    configType: ControlType.View
  },
  [ControlType.Panel]: {
    component: OpenPanel,
    configType: ControlType.Panel
  },
  [ControlType.Section]: {
    component: ReadPanel,
    configType: ControlType.Panel
  },
  [ControlType.CallToAction]: {
    component: OpenPanel,
    configType: ControlType.Panel
  },
  [ControlType.ActionBar]: {
    component: OpenPanel,
    configType: ControlType.Panel
  },
  [ControlType.TextBox]: {
    component: UI.DisplayText,
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-text-read')],
    configType: ControlType.TextBox
  },
  [ControlType.TextArea]: {
    component: UI.DisplayText,
    enhancers: [Enhance.withSize({xl: 8}), Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-text-read')],
    configType: ControlType.TextArea
  },
  [ControlType.NumberBox]: {
    component: UI.DisplayNumber,
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withTileSize({md: 6, lg: 4}),
                Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-number-read')],
    configType: ControlType.NumberBox
  },

  [ControlType.DateTime]: {
    component: UI.DisplayDate,
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-date-read')],
    configType: ControlType.DateTime
  },

  [ControlType.Date]: {
    component: UI.DisplayDate,
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-date-read')],
    configType: ControlType.Date
  },

  [ControlType.CheckBox]: {
    component: UI.DisplayBoolean,
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-boolean-read')],
    configType: ControlType.CheckBox
  },

  [ControlType.SelectMultiple]: {
    component: UI.DisplayCodes,
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-codes-read')],
    configType: ControlType.SelectMultiple
  },
  [ControlType.SelectMultipleHierarchy]: {
    component: UI.DisplayCodesHierarchy,
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-codes-hierarchy-read')],
    configType: ControlType.SelectMultipleHierarchy
  },
  [ControlType.SelectSingle]: {
    component: UI.DisplayCodes,
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withTileSize({md: 6, lg: 4}),
                Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-codes-read')],
    configType: ControlType.SelectSingle
  },
  [ControlType.SelectSingleHierarchy]: {
    component: UI.DisplayCodesHierarchy,
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-codes-hierarchy-read')],
    configType: ControlType.SelectSingleHierarchy
  },
  [ControlType.SelectSingleShortList]: {
    component: UI.DisplayCodes,
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-codes-read')],
    configType: ControlType.SelectSingleShortList
  },

  [ControlType.EntityKeyCategorySelectSingleShortList]: {
    component: UI.DisplayCodes,
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-codes-read')],
    configType: ControlType.EntityKeyCategorySelectSingleShortList
  },

  [ControlType.TileView]: {
    component: UI.TileView,
    configType: ControlType.TileView,
    selectors: [Select.activeChildItem],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.Tile]: {
    component: UI.Tile,
    selectors: [
      Select.primaryKeyFromContext(),
      Select.expandAll,
      Select.casePermissions,
      Select.editDocumentItemVisibility
    ],
    configType: ControlType.Tile
  },

  [ControlType.CommentTileView]: {
    component: appComponents.CommentTileView,
    configType: ControlType.CommentTileView,
    enhancers: [Enhance.withSize({lg: 8}), Enhance.withClassNames('no-content-read')],
    selectors: [Select.activeChildItem],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.CommentTile]: {
    component: appComponents.CommentTile,
    configType: ControlType.CommentTile
  },

  [ControlType.SliderRating]: {
    component: UI.DisplayCodes,
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withClassNames('display-codes-read')],
    configType: ControlType.DisplayCodes
  },

  [ControlType.EntityKeyCategorySliderRating]: {
    component: UI.DisplayCodes,
    enhancers: [Enhance.withSize({sm: 4, md: 4, lg: 4}), Enhance.withExpandAllSize({md: 6}), Enhance.withClassNames('display-codes-read')],
    configType: ControlType.DisplayCodes
  },

  [ControlType.ButtonList]: {
    component: UI.Hidden,
    configType: ControlType.ButtonList
  },

  [ControlType.HeaderPanel]: {
    component: appComponents.ReadHeaderPanel,
    enhancers: [
      AddFeature.withSharing(SharePreset.case), Enhance.withProperty('enableStickyHeader', true), 
      withCopyRiskEvaluation(), withGetUiDefinition, AddFeature.withCallsToActions, 
      Enhance.withProperty('reloadOnCallsToActions', true), AddFeature.withUnlocking(UnlockPreset.case),
      AddFeature.withConnectedCases
    ],
    selectors: [
      Select.sharedState,
      Select.headerVisibilityConfiguration,
      Select.casePermissions,
      Select.urlToCase(),
      Select.caseId,
      Select.expandAll,
      Select.templateURL,
      Select.lossPotentialEvaluationValues,
      Select.fieldValues([
                          {fieldName: (columnName[tableName.trans]).confidentialIndicator,
                            dataTag: (columnName[tableName.trans]).confidential}
                        ]),
      Select.entityId, Select.connectedCasesMaxSequence, Select.connectedDrafts,
      Select.favouriteComponent,
      Select.connectedCasesIdsByConnectionType
    ],
    configType: ControlType.HeaderPanel
  },

  [ControlType.DisplayDate]: {
    component: UI.DisplayDate,
    enhancers: [Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.DisplayDate
  },

  [ControlType.DisplayNumber]: {
    component: UI.DisplayNumber,
    enhancers: [Enhance.withTileSize({md: 6, lg: 4}), Enhance.withSize({md: 6, lg: 4})],
    configType: ControlType.DisplayNumber
  },

  [ControlType.DisplayNumberUnitOfMeasure]: {
    component: appComponents.DisplayNumberUnitOfMeasure,
    enhancers: [Enhance.withTileSize({md: 6, lg: 4})],
    selectors: [Select.childValues],
    configType: ControlType.DisplayNumberUnitOfMeasure
  },

  [ControlType.DisplayText]: {
    component: UI.DisplayText,
    enhancers: [Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.DisplayText
  },

  [ControlType.DisplayCodes]: {
    component: UI.DisplayCodes,
    enhancers: [Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.DisplayCodes
  },

  [ControlType.DisplayCodesUnitOfMeasure]: {
    component: appComponents.DisplayCodesUnitOfMeasure,
    enhancers: [Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.DisplayCodesUnitOfMeasure
  },

  [ControlType.DisplayCodesHierarchy]: {
    component: UI.DisplayCodesHierarchy,
    enhancers: [Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.DisplayCodesHierarchy
  },

  [ControlType.DisplayBoolean]: {
    component: UI.DisplayBoolean,
    enhancers: [Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.DisplayBoolean
  },

  [ControlType.LinkHeading]: {
    component: UI.LinkHeading,
    selectors: [Select.urlToConnectedCase(), Select.expandAll],
    enhancers: [Enhance.withClassNames('compact', true)],
    configType: ControlType.LinkHeading
  },

  [ControlType.FluidPanel]: {
    component: UI.FluidPanel,
    configType: ControlType.FluidPanel
  },

  [ControlType.ExpandableText]: {
    component: UI.ExpandableText,
    selectors: [Select.expandAll],
    configType: ControlType.ExpandableText
  },

  [ControlType.ProcessPanel]: {
    component: UI.ProcessPanel,
    configType: ControlType.ProcessPanel
  },

  [ControlType.GroupPanel]: {
    component: UI.GroupPanel,
    enhancers: [Enhance.withSize({xl: 12}), Enhance.withProperty('label.required', false)],
    configType: ControlType.GroupPanel
  },

  [ControlType.FlexPanel]: {
    component: UI.FlexPanel,
    selectors: [Select.firstSectionId, Select.activeSectionState],
    enhancers: [Enhance.withRenderOnFirstTabOnly()],
    configType: ControlType.FlexPanel
  },

  [ControlType.ColumnsPanel]: {
    component: UI.ColumnsPanel,
    configType: ControlType.ColumnsPanel
  },

  [ControlType.DetailForm]: {
    component: UI.DetailFormPanel,
    configType: ControlType.DetailForm
  },

  [ControlType.DisplayChildValues]: {
    component: UI.DisplayChildValues,
    selectors: [Select.childValues],
    enhancers: [Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.DisplayChildValues
  },

  [ControlType.FactBox]: {
    component: caseComponents.FactBox,
    selectors: [
      Select.caseId,
      Select.riskValues
    ],
    configType: ControlType.FactBox
  },

  [ControlType.ConnectedCasesTileView]: {
    component : caseComponents.ConnectedCasesTileView,
    selectors: [
      Select.entityId, Select.connectedDrafts,
      Select.activeChildItem,
      Select.caseId,
      Select.changeCaseSequence
    ],
    enhancers: [
      AddFeature.withConnectedCases, 
      AddFeature.withConnectedCasePermissions
    ],
    configType: ControlType.ConnectedCasesTileView,
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.ConnectedCasesTile]: {
    component: caseComponents.ConnectedCasesTile,
    selectors: [
      Select.primaryKeyFromContext(),
      Select.primaryKeyFromContextExpanded('connectionTypeId'),
      Select.connectedCasePermissions,
      Select.caseId,
      Select.changeCaseSequence
    ],
    enhancers: [AddFeature.withConnectionSequenceUpdate, AddFeature.withConnectedCasePermissions],
    configType: ControlType.ConnectedCasesTile
  },

  [ControlType.FileUploader]: {
    component: UI.FileUploader,
    selectors: [Select.print],
    enhancers: [AddFeature.withFileDownload()],
    configType: ControlType.FileUploader
  },

  [ControlType.CodeSelectorTileView]: {
    component: appComponents.CodeSelectorTileView,
    selectors: [Select.childEntityTypeKeys, Select.activeChildItem],
    configType: ControlType.CodeSelectorTileView,
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.CodeTitleTile]: {
    component: appComponents.CodeTitleTile,
    selectors: [Select.primaryKeyFromContext(), Select.expandAll],
    enhancers: [Enhance.withProperty('renderDetailsInline', false)],
    configType: ControlType.CodeTitleTile
  },

  [ControlType.LossPotentialEvaluation]: {
    component: caseComponents.LossPotentialEvaluation,
    selectors: [Select.primaryKeyFromContext(), Select.editFooterDetailsButtonVisibility],
    enhancers: [Enhance.withProperty('renderDetailsInline', false)],
    configType: ControlType.LossPotentialEvaluation
  },

  [ControlType.LossPotentialEvaluationTileView]: {
    component: caseComponents.LossPotentialEvaluationTileView,
    selectors: [Select.childEntities],
    configType: ControlType.LossPotentialEvaluationTileView,
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.LossPotentialConsequenceEvaluation]: {
    component: caseComponents.LossPotentialConsequenceEvaluation,
    selectors: [Select.consequenceRiskValues],
    configType: ControlType.LossPotentialConsequenceEvaluation
  },

  [ControlType.LossPotentialConsequenceEvaluationTileView]: {
    component: appComponents.CodeSelectorTileView,
    configType: ControlType.LossPotentialConsequenceEvaluationTileView,
    selectors: [Select.activeChildItem],
    enhancers: [Enhance.withProperty('rowClassName', 'col-12 col-sm-6 col-lg-4')],
    iterate: { type: IteratorType.DataRows }
  },
  
  [ControlType.LossPotentialConsequenceEvaluationTileRiskMatrixPanel]: {
    component: UI.ColumnsPanel,
    enhancers: [Enhance.withProperty('columns', '12'), Enhance.withClassNames('risk-matrix-panel')],
    configType: ControlType.LossPotentialConsequenceEvaluationTileRiskMatrixPanel
  },

  [ControlType.LossPotentialConsequenceEvaluationTileDetailPanel]: {
    component: UI.ColumnsPanel,
    enhancers: [Enhance.withProperty('columns', '12')],
    configType: ControlType.LossPotentialConsequenceEvaluationTileDetailPanel
  },

  [ControlType.CauseCategoryTileView]: {
    component: appComponents.CategoryTileView,
    selectors: [Select.childEntityFieldValueAsOptions(tableName.causes, 'CauseCategory'), Select.activeChildItem],
    configType: ControlType.CauseCategoryTileView,
    iterate: { type: IteratorType.CodeTable }
  },

  [ControlType.CheckListCategoryTileView]: {
    component: appComponents.CategoryTileView,
    configType: ControlType.CheckListCategoryTileView,
    selectors: [Select.activeChildItem],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.CheckListCategoryTile]: {
    component: appComponents.CategoryTile,
    selectors: [Select.primaryKeyFromContext()],
    configType: ControlType.CheckListCategoryTile
  },

  [ControlType.CheckListEvaluationPanel]: {
    component: UI.FlexPanel,
    configType: ControlType.CheckListEvaluationPanel,
    enhancers: [Enhance.withHideIfPropValueNotInVisibleForValues('value')]
  },

  [ControlType.CategoryTileView]: {
    component: appComponents.CategoryTileView,
    configType: ControlType.CategoryTileView,
    selectors: [Select.activeChildItem],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.CategoryTile]: {
    component: appComponents.CategoryTile,
    selectors: [Select.primaryKeyFromContext()],
    configType: ControlType.CategoryTile
  },

  [ControlType.DisplayNumericHeader]: {
    component: UI.DisplayNumericHeader,
    configType: ControlType.DisplayNumericHeader
  },

  [ControlType.ConsequenceTypeTileView]: {
    component: appComponents.CodeSelectorTileView,
    configType: ControlType.ConsequenceTypeTileView,
    selectors: [Select.activeChildItem],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.ConsequenceTypeTile]: {
    component: appComponents.CodeTitleTile,
    selectors: [Select.primaryKeyFromContext()],
    configType: ControlType.ConsequenceTypeTile
  },

  [ControlType.ConsequenceTileView]: {
    component: UI.TileView,
    selectors: [Select.primaryKeyFromContextExpanded('consequenceType'), Select.activeChildItem],
    configType: ControlType.ConsequenceTileView,
    enhancers: [Enhance.withHideIfPropValueNotInVisibleForValues('consequenceType')],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.SectionPanel]: {
    component: UI.SectionPanel,
    selectors: [
      Select.firstSectionId,
      Select.activeSectionState,
      Select.nextAndPreviousSection
    ],
    enhancers: [
      Enhance.withRenderActiveSection(),
      Enhance.withSectionTab()
    ],
    configType: ControlType.SectionPanel
  },

  [ControlType.FlexRowPanel]: {
    component: UI.FlexRowPanel,
    configType: ControlType.FlexRowPanel
  },

  [ControlType.LongDescription]: {
    component: UI.LongDescription,
    configType: ControlType.LongDescription
  },

  [ControlType.SectionSummaryPanel]: {
    component: caseComponents.SectionSummary,
    enhancers: [Enhance.withSize({md: 12})],
    configType: ControlType.SectionSummaryPanel
  },

  [ControlType.TileTopZone]: {
    component: UI.TileTopZone,
    configType: ControlType.TileTopZone
  },

  [ControlType.DisplayNumericSum]: {
    component: UI.DisplayNumber,
    selectors: [Select.childValuesTotals('valueItem')],
    configType: ControlType.DisplayNumericSum
  },

  [ControlType.AttachLinkTileView]: {
    component: caseComponents.AttachLinkTileView,
    selectors: [Select.attachLinkValues, Select.activeChildItem],
    configType: ControlType.AttachLinkTileView,
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.DisplaySafeAnchor]: {
    component: appComponents.DisplaySafeAnchor,
    configType: ControlType.DisplaySafeAnchor
  },

  [ControlType.AttachLinkTile]: {
    component: caseComponents.AttachLinkTile,
    selectors: [Select.fieldValues([
                  {
                    fieldName: (columnName[tableName.link]).anchorIndicator,
                    dataTag: (columnName[tableName.link]).linkUrl
                  }])],
    configType: ControlType.AttachLinkTile
  },

  [ControlType.SubstanceCategoryTileView]: {
    component: appComponents.CategoryTileView,
    selectors: [Select.childEntityFieldValueAsOptions(tableName.green, 'EnvValSubstanceCategory'), Select.activeChildItem],
    configType: ControlType.SubstanceCategoryTileView,
    iterate: { type: IteratorType.CodeTable }
  },

  [ControlType.EnvironmentalValuesTileView]: {
    component: appComponents.CodeSelectorTileView,
    selectors: [Select.primaryKeyFromContextExpanded('categoryId'), Select.activeChildItem],
    configType: ControlType.EnvironmentalValuesTileView,
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.SafeAnchor]: {
    component: appComponents.SafeAnchor,
    enhancers: [Enhance.withSize({xl: 8})],
    configType: ControlType.SafeAnchor
  },

  [ControlType.InteractionTileView]: {
    component: appComponents.CategoryTileView,
    selectors: [Select.childEntityFieldValueAsOptions(tableName.checkListInteraction, 'CheckListInteraction'), Select.activeChildItem],
    configType: ControlType.InteractionTileView,
    iterate: { type: IteratorType.CodeTable }
  },

  [ControlType.InteractionTileViewDrugReaction]: {
    component: UI.TileView,
    selectors: [Select.childEntityFieldValueAsOptions(tableName.drugReactionInteraction, 'DrgReacInteraction'), Select.activeChildItem],
    configType: ControlType.InteractionTileViewDrugReaction,
    iterate: { type: IteratorType.CodeTable }
  },

  [ControlType.InteractionTile]: {
    component: appComponents.CompactCodeTitleTile,
    selectors: [Select.primaryKeyFromContext()],
    configType: ControlType.InteractionTile
  },

  [ControlType.CausesTileView]: {
    component: appComponents.CodeSelectorTileView,
    selectors: [Select.childEntityTypeKeys, Select.activeChildItem],
    configType: ControlType.CausesTileView,
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.CompactCodeTitleTile]: {
    component: appComponents.CompactCodeTitleTile,
    selectors: [Select.primaryKeyFromContext()],
    configType: ControlType.CompactCodeTitleTile
  },

  [ControlType.SummaryTileView]: {
    component: caseComponents.SummaryTileView,
    configType: ControlType.SummaryTileView,
    selectors: [Select.activeChildItem],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.TitleWrapperPrimaryKey]: {
    component: appComponents.TitleWrapper,
    selectors: [Select.primaryKeyFromContext('title')],
    configType: ControlType.TitleWrapperPrimaryKey
  },

  [ControlType.ReferenceTileView]: {
    component: caseComponents.ReferenceSelectTileView,
    selectors: [Select.activeChildItem],
    configType: ControlType.ReferenceTileView,
    enhancers: [Enhance.withPrimaryKeyAsOptionIteratorId, Enhance.withSize({lg: 12})],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.ReferenceTile]: {
    component: appComponents.CompactCodeTitleTile,
    selectors: [Select.referenceCodeDataTag, Select.referenceFieldValueAsPrimaryKey],
    configType: ControlType.ReferenceTile,
    enhancers: []
  },

  [ControlType.DisplayCodesReference]: {
    component: UI.DisplayCodes,
    enhancers: [Enhance.withTileSize({md: 6, xl: 4})],
    configType: ControlType.DisplayCodesReference
  },

  [ControlType.ReferenceDate]: {
    component: UI.DisplayDate,
    selectors: [Select.referenceFieldValue],
    enhancers: [Enhance.withHideIfPropValueNotInVisibleForValues('referenceType'), Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.ReferenceDate
  },

  [ControlType.ReferenceDateTime]: {
    component: UI.DisplayDate,
    selectors: [Select.referenceFieldValue],
    enhancers: [Enhance.withHideIfPropValueNotInVisibleForValues('referenceType'), Enhance.withTileSize({md: 6, lg: 8})],
    configType: ControlType.ReferenceDateTime
  },

  [ControlType.ReferenceTextBox]: {
    component: UI.DisplayText,
    selectors: [Select.referenceFieldValue],
    enhancers: [Enhance.withHideIfPropValueNotInVisibleForValues('referenceType'), Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.ReferenceTextBox
  },

  [ControlType.ReferenceNumberBox]: {
    component: UI.DisplayNumber,
    selectors: [Select.referenceFieldValue],
    enhancers: [Enhance.withHideIfPropValueNotInVisibleForValues('referenceType'), Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.ReferenceNumberBox
  },

  [ControlType.ReferenceEntityKeyCategorySelectSingleShortList]: {
    component: UI.DisplayCodes,
    selectors: [Select.referenceFieldValue],
    enhancers: [Enhance.withHideIfPropValueNotInVisibleForValues('referenceType'), Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.ReferenceEntityKeyCategorySelectSingleShortList
  },

  [ControlType.ReferenceCheckBox]: {
    component: UI.DisplayCodes,
    selectors: [Select.referenceFieldValue],
    enhancers: [Enhance.withHideIfPropValueNotInVisibleForValues('referenceType'), Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.ReferenceCheckBox
  },

  [ControlType.ReferenceSelectSingleHierarchy]: {
    component: UI.DisplayCodesHierarchy,
    selectors: [Select.referenceFieldValue],
    enhancers: [Enhance.withHideIfPropValueNotInVisibleForValues('referenceType'), Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.ReferenceSelectSingleHierarchy
  },

  [ControlType.ReferenceSelectSingle]: {
    component: UI.DisplayCodes,
    selectors: [Select.referenceFieldValue],
    enhancers: [Enhance.withHideIfPropValueNotInVisibleForValues('referenceType'), Enhance.withSize({md: 6, xl: 4})],
    configType: ControlType.ReferenceSelectSingle
  },

  [ControlType.SurveyLink]: {
    component: UI.Link,
    selectors: [Select.templateURL],
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3})],
    configType: ControlType.SurveyLink
  },

  [ControlType.DisplaySurveyLink]: {
    component: UI.Link,
    selectors: [Select.templateURL],
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3})],
    configType: ControlType.SurveyLink
  },

  [ControlType.Link]: {
    component: UI.Link,
    selectors: [Select.domainTemplateUrl],
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3})],
    configType: ControlType.Link
  },

  [ControlType.Signature]: {
    component: UI.DisplayDate,
    selectors: [],
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.Signature
  },

  [ControlType.RiskMatrix]: {
    component: appComponents.RiskMatrix,
    selectors: [() => ({ readOnly: true })],
    enhancers: [AddFeature.withRiskMatrix],
    configType: ControlType.RiskMatrix
  },

  [ControlType.DisplayInsuranceBalance]: {
    component: UI.DisplayNumber,
    selectors: [Select.diffFieldValueAndChildValuesTotals('valueItem', (columnName[tableName.economy]).costEstimate)],
    enhancers: [Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-number-read')],
    configType: ControlType.DisplayInsuranceBalance
  },

  [ControlType.IndicatorCodeSelectorTileView]: {
    component: appComponents.CodeSelectorTileView,
    selectors: [Select.childEntityTypeKeys, Select.activeChildItem],
    configType: ControlType.IndicatorCodeSelectorTileView,
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.AddDocumentItemLinkButton]: {
    component: UI.Hidden,
    configType: ControlType.AddDocumentItemLinkButton
  },

  [ControlType.ProcessingLogView]: {
    component: appComponents.LogView,
    configType: ControlType.ProcessingLogView,
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.ProcessingLogDetails]: {
    component: appComponents.LogDetails,
    configType: ControlType.ProcessingLogDetails
  },

  [ControlType.ProcessingLogLink]: {
    component: appComponents.ReadProcessingLogLink,
    selectors: [Select.childEntityCount([
      {
        entityPath: [{ entityType: tableName.trans }, { entityType: tableName.transLog }],
        propName:  (columnName[tableName.transLog] as any).caseLogs,
        dataTag: (columnName[tableName.transLog] as any).CaseLogNo
      }])],
    configType: ControlType.ProcessingLogLink
  },

  [ControlType.MailLogLink]: {
    component: appComponents.MailLogLink,
    configType: ControlType.MailLogLink
  },

  [ControlType.CaseLogLink]: {
    component: appComponents.CaseLogLink,
    enhancers: [AddFeature.withCaseLogDownload],
    selectors: [Select.childValues, Select.primaryKeyFromContext()],
    configType: ControlType.CaseLogLink
  },

  [ControlType.MailLogDetails]: {
    component: appComponents.LogDetails,
    configType: ControlType.MailLogDetails
  },

  [ControlType.AddNewCaseButton]: {
    component: caseComponents.AddNewCaseButtonRead,
    selectors: [
      Select.entityId, Select.connectedCasesMaxSequence, Select.connectedDrafts
    ],
    configType: ControlType.AddNewCaseButton
  },

  [ControlType.CompactTileHeader]: {
    component: appComponents.CompactTileHeader,
    selectors: [Select.tileHeaderPrimaryKey],
    configType: ControlType.CompactTileHeader
  },

  [ControlType.ConnectedCasesFactbox]: {
    component: caseComponents.ConnectedCasesFactbox,
    configType: ControlType.ConnectedCasesFactbox,
    enhancers: [Enhance.withClassNames('compact')],
    selectors: [
      Select.connectedCasesRiskValues
    ]},

  [ControlType.CheckForDuplicateRegistrationsButton]: {
    component: UI.Hidden,
    configType: ControlType.CheckForDuplicateRegistrationsButton
  },

  [ControlType.CompactTile]: {
    component: UI.CompactTile,
    selectors: [
      Select.primaryKeyFromContext(),
      Select.expandAll,
      Select.casePermissions,
      Select.editDocumentItemVisibility,
      Select.editDetailsActionOverride
    ],    
    configType: ControlType.CompactTile
  },

  [ControlType.BarrierInspectionTileView]: {
    component: caseComponents.SummaryTileView,
    configType: ControlType.BarrierInspectionTileView,
    selectors: [ Select.activeChildItem ],
    enhancers: [ Enhance.withProperty('doubleWidth', true)],
    iterate: { type: IteratorType.DataRows }
  },

  [ControlType.DisplayNumberBarrierInspection]: {
    component: UI.DisplayNumber,
    enhancers: [Enhance.withSize({lg: 12})],
    configType: ControlType.DisplayNumber
  },

  [ControlType.DisplayCodesStatus]: {
    component: UI.DisplayCodes,
    enhancers: [Enhance.withProperty('displayBackgroundColor', 'false'), 
                Enhance.withProperty('style', 'primary')],
    configType: ControlType.DisplayCodesStatus
  },

  [ControlType.SelectSingleSignature]: {
    component: UI.DisplayCodes,
    selectors: [],
    enhancers: [Enhance.withSize({md: 6, lg:4, xl:3}), Enhance.withTileSize({md: 6, lg: 4})],
    configType: ControlType.SelectSingleSignature
  },
  
  [ControlType.DisplayEnvironmentalPreviousValues]: {
    component: caseComponents.DisplayEnvironmentalPreviousValuesComponent,
    selectors: [Select.previousEnvironmentalValues, Select.sectionLinks],
    enhancers: [Enhance.withProperty('hideIfNoValue', true), Enhance.withClassNames('display-number-read'),
                Enhance.withSize({md: 6, xl: 4})],
    configType: ControlType.DisplayEnvironmentalPreviousValues
  },
  [ControlType.BadgeListFileUploader]: {
    component: caseComponents.BadgeListFileUploader,
    enhancers: [AddFeature.withFileDownload()],
    configType: ControlType.BadgeListFileUploader
  },
  [ControlType.Thumbnail]: {
    component: caseComponents.Thumbnail,
    enhancers: [AddFeature.withFileDownload()],
    configType: ControlType.Thumbnail
  },
  [ControlType.DetailsPanelHeader]: {
    component: UI.DetailFormPanelHeader,
    selectors: [Select.primaryKeyFromContext()],
    configType: ControlType.DetailsPanelHeader
  },
  [ControlType.FileUploaderList]: {
    component: UI.FileUploaderList,
    selectors: [Select.print],
    enhancers: [AddFeature.withFileDownload()],
    configType: ControlType.FileUploaderList
  },
  [ControlType.ChangeLogLink]: {
    component: appComponents.ChangeLogLink,
    selectors: [Select.caseLogValues, Select.primaryKeyFromContext(), Select.caseId],
    configType: ControlType.ChangeLogLink
  },

  [ControlType.LossPotentialEvaluationFooter]: {
    component: caseComponents.LossPotentialEvaluationFooter,
    configType: ControlType.LossPotentialEvaluationFooter
  },

  [ControlType.LossPotentialConsequenceEvaluationFooter]: {
    component: caseComponents.LossPotentialConsequenceEvaluationFooter,
    selectors: [Select.childValues],
    configType: ControlType.LossPotentialConsequenceEvaluationFooter
  },

  [ControlType.ButtonGroupPanel]: {
    component: UI.ButtonGroupPanel,
    selectors: [Select.childEntitiesReadOnly],
    configType: ControlType.ButtonGroupPanel
  },

  [ControlType.ActionFactItem]: {
    component: caseComponents.ActionFactItem,
    configType: ControlType.ActionFactItem,
    selectors: [
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.action }],
          propName: (caseData.columnName[caseData.tableName.action] as any).numberOfActions
        },
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.action }],
          propName: (caseData.columnName[caseData.tableName.action] as any).numberOfClosedActions,
          dataTag: (caseData.columnName[caseData.tableName.action] as any).actionCompletedDate
        }]),
      Select.urlToCase(),
      Select.reportCategory
    ]
  },

  [ControlType.AssessmentFactItem]: {
    component: caseComponents.AssessmentFactItem,
    configType: ControlType.AssessmentFactItem,
    selectors: [
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.assessment }],
          propName: (caseData.columnName[caseData.tableName.assessment] as any).numberOfAssessments
        }
      ]),
      Select.urlToCase()
    ]
  },

  [ControlType.AttachedFilesFactItem]: {
    component: caseComponents.AttachedFilesFactItem,
    configType: ControlType.AttachedFilesFactItem,
    selectors: [
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.object }],
          propName: (caseData.columnName[caseData.tableName.object] as any).numberOfFiles
        },
        {
          entityPath: [{ entityType: caseData.tableName.trans },
                       { entityType: caseData.tableName.attachmentType, id: 2},
                       { entityType: caseData.tableName.link }],
                       propName: (caseData.columnName[caseData.tableName.link] as any).numberOfLinks
        }
      ]),
      Select.urlToCase()
    ]
  },

  [ControlType.BowtieFactItem]: {
    component: caseComponents.BowtieFactItem,
    configType: ControlType.BowtieFactItem,
    selectors: [Select.bowtieSupported, Select.caseId]
  },

  [ControlType.CausesFactItem]: {
    component: caseComponents.CausesFactItem,
    configType: ControlType.CausesFactItem,
    selectors: [ 
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.causes }],
          propName: (caseData.columnName[caseData.tableName.causes] as any).numberOfCauses
        }
      ]),
      Select.urlToCase()
    ]
  },

  [ControlType.CommentsFactItem]: {
    component: caseComponents.CommentsFactItem,
    configType: ControlType.CommentsFactItem,
    selectors: [
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.comment }],
          propName: (caseData.columnName[caseData.tableName.comment] as any).numberOfComments
        }
      ]),
      Select.urlToCase()
    ]
  },

  [ControlType.ConnectedCasesFactItem]: {
    component: caseComponents.ConnectedCasesFactItem,
    configType: ControlType.ConnectedCasesFactItem,
    selectors: [
      Select.connectedCasesIdsIrrespectiveOfConnectionType,
      Select.urlToCase()
    ]
  },

  [ControlType.ConsequencesFactItem]: {
    component: caseComponents.ConsequencesFactItem,
    configType: ControlType.ConsequencesFactItem,
    selectors: [
      Select.riskValues,
      Select.childEntityValuesAsProperty('childValueItems', [
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.consequences }],
          propName: (caseData.columnName[caseData.tableName.consequences] as any).actConsConsequenceIcons
        }]),
      Select.urlToCase()
    ]
  },

  [ControlType.ChecklistFactItem]: {
    component: caseComponents.ChecklistFactItem,
    configType: ControlType.ChecklistFactItem,
    selectors: [
      Select.checklistValues,
      Select.urlToCase()
    ]
  },

  [ControlType.IntegrityStatusFactItem]: {
    component: caseComponents.IntegrityStatusFactItem,
    configType: ControlType.IntegrityStatusFactItem,
    selectors: [
      Select.integrityValues,
      Select.urlToCase()
    ]
  },

  [ControlType.IntegrityStatusBarrierEvalFactItem]: {
    component: caseComponents.IntegrityStatusBarrierEvalFactItem,
    configType: ControlType.IntegrityStatusBarrierEvalFactItem,
    selectors: [
      Select.integrityStatusBarrierEvalValues,
      Select.urlToCase()
    ]
  },

  [ControlType.InvolvedDrugFactItem]: {
    component: caseComponents.InvolvedDrugFactItem,
    configType: ControlType.InvolvedDrugFactItem,
    selectors: [
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.involvedDrug }],
          propName: (caseData.columnName[caseData.tableName.involvedDrug] as any).numberOfInvolvedDrugs
        }
      ]),
      Select.urlToCase()
    ]
  },

  [ControlType.InvolvedPersonFactItem]: {
    component: caseComponents.InvolvedPersonFactItem,
    configType: ControlType.InvolvedPersonFactItem,
    selectors: [
      Select.childEntityCount([
        {
          entityPath: [{ entityType: caseData.tableName.trans }, { entityType: caseData.tableName.involvedPerson }],
          propName: (caseData.columnName[caseData.tableName.involvedPerson] as any).numberOfInvolvedPersons
        }
      ]),
      Select.urlToCase()
    ]
  },

  [ControlType.ResidualRiskFactItem]: {
    component: caseComponents.ResidualRiskFactItem,
    configType: ControlType.ResidualRiskFactItem,
    selectors: [
      Select.residualRiskValues,
      Select.urlToCase()
    ]
  },

  [ControlType.RiskFactItem]: {
    component: caseComponents.RiskFactItem,
    configType: ControlType.RiskFactItem,
    selectors: [
      Select.riskValues,
      Select.urlToCase()
    ]
  },
  [ControlType.FactItemPanel]: {
    component: caseComponents.FactItemPanel,
    configType: ControlType.FactItemPanel
  },

  [ControlType.ConnectedCasesBowtieFactItem]: {
    component: caseComponents.ConnectedCasesBowtieFactItem,
    configType: ControlType.ConnectedCasesBowtieFactItem,
    selectors: [
      Select.connectedCasesBowtieSupported,
      Select.primaryKeyFromContext()
    ]
  },      
  
  [ControlType.ConnectedCasesRiskFactItem]: {
    component: caseComponents.ConnectedCasesRiskFactItem,
    configType: ControlType.ConnectedCasesRiskFactItem,
    selectors: [
      Select.connectedCasesRiskValues,
      Select.urlToConnectedCase(),
      Select.caseTypeLinkDomain
    ]
  },

  [ControlType.ConnectedCasesResidualRiskFactItem]: {
    component: caseComponents.ConnectedCasesResidualRiskFactItem,
    configType: ControlType.ConnectedCasesResidualRiskFactItem,
    selectors: [
      Select.connectedCasesResidualRiskValues,
      Select.urlToConnectedCase()
    ]
  },

  [ControlType.ConnectedCasesIntegrityStatusFactItem]: {
    component: caseComponents.ConnectedCasesIntegrityStatusFactItem,
    configType: ControlType.ConnectedCasesIntegrityStatusFactItem,
    selectors: [
      Select.connectedCasesIntegrityValues,
      Select.urlToConnectedCase(),
      Select.caseTypeLinkDomain
    ]
  },

  [ControlType.ConnectedCasesIntegrityStatusBarrierEvalFactItem]: {
    component: caseComponents.ConnectedCasesIntegrityStatusBarrierEvalFactItem,
    configType: ControlType.ConnectedCasesIntegrityStatusBarrierEvalFactItem,
    selectors: [
      Select.connectedCasesintegrityStatusBarrierEvalValues,
      Select.urlToConnectedCase()
    ]
  },

  [ControlType.ConnectedCasesActionFactItem]: {
    component: caseComponents.ConnectedCasesActionFactItem,
    configType: ControlType.ConnectedCasesActionFactItem,
    selectors: [
      Select.connectedCasesActionCount,
      Select.urlToConnectedCase()
    ]
  },

  [ControlType.ImagesFactItem]: {
    component: caseComponents.ImagesFactItem,
    configType: ControlType.ImagesFactItem,
    selectors: [
      Select.riskValues
    ],
    enhancers: [AddFeature.withFileDownload(caseData.tableName.object)]
  },

  [ControlType.DisplayLink]: {
    component: UI.DisplayLink,
    configType: ControlType.DisplayLink
  }
};
